<template>
  <div class="focus-tasks">
    <div class="focus-tasks-drag-icon">
      <svg version="1.1" id="Artwork" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
           viewBox="0 0 32 32" style="enable-background:new 0 0 32 32;" xml:space="preserve">
        <path class="st0" d="M32.056,8.496c0-1.637-1.331-2.961-2.961-2.961c-1.357,0-2.498,0.92-2.85,2.166H18.73
          c-0.261-1.22-1.344-2.139-2.635-2.139c-1.305,0-2.381,0.907-2.635,2.139H5.867C5.573,6.63,4.686,5.789,3.59,5.586
          c-1.07-0.202-2.166,0.189-2.857,1.018C0.173,7.289-0.056,8.182,0.107,9.063c0.222,1.174,1.161,2.113,2.335,2.335
          c0.189,0.039,0.385,0.052,0.574,0.052c0.887,0,1.715-0.391,2.283-1.076c0.267-0.326,0.457-0.698,0.567-1.089h7.521v2.74
          l-0.065,9.288l-0.939-0.718c-1.213-1.057-4.07-2.355-6.36,0.157c-0.254,0.28-0.28,0.691-0.059,0.998
          c0.065,0.091,1.598,2.237,4.044,4.559c0.32,0.307,0.828,0.287,1.128-0.033c0.307-0.32,0.287-0.828-0.033-1.128
          c-1.605-1.52-2.818-2.987-3.418-3.764c1.663-1.22,3.444,0.241,3.653,0.424c0.013,0.013,0.026,0.02,0.039,0.033l2.244,1.729
          c0.241,0.183,0.567,0.222,0.835,0.085c0.274-0.13,0.444-0.411,0.45-0.711l0.072-10.906V8.241c0-0.007,0-0.013,0-0.026
          c0.02-0.6,0.502-1.063,1.096-1.063c0.607,0,1.096,0.496,1.096,1.096c0,0.033,0,0.065,0.007,0.098l0.854,7.084
          c0.039,0.352,0.313,0.633,0.659,0.691c0.052,0.007,5.277,0.9,9.014,3.333c0.137,0.907,0.45,3.594-0.17,6.073
          c-0.111,0.431,0.15,0.861,0.581,0.972c0.065,0.02,0.13,0.026,0.196,0.026c0.359,0,0.685-0.241,0.776-0.607
          c0.848-3.379,0.17-6.94,0.137-7.09c-0.039-0.202-0.157-0.385-0.333-0.502c-3.32-2.283-7.743-3.34-9.328-3.666l-0.646-5.368h7.325
          c0.352,1.246,1.494,2.166,2.85,2.166C30.725,11.457,32.056,10.126,32.056,8.496z M4.073,9.363c-0.32,0.385-0.822,0.567-1.324,0.47
          C2.221,9.735,1.784,9.298,1.686,8.77c-0.078-0.417,0.02-0.828,0.287-1.148c0.261-0.313,0.646-0.496,1.05-0.496
          c0.091,0,0.183,0.007,0.274,0.026C3.825,7.25,4.262,7.687,4.36,8.215C4.438,8.639,4.334,9.043,4.073,9.363z M29.094,9.859
          c-0.724,0-1.311-0.567-1.357-1.272c0.007-0.033,0.007-0.059,0.007-0.091s-0.007-0.059-0.007-0.091
          c0.046-0.711,0.633-1.272,1.357-1.272c0.75,0,1.363,0.613,1.363,1.363C30.458,9.246,29.845,9.859,29.094,9.859z"/>
      </svg>
    </div>
    <div class="focus-tasks-columns">
      <div class="focus-tasks-column"
           v-bind:id="'statusColumn-' + status.id"
           @dragover="dragOverHandle(status.id)"
           @dragleave="this.dragOverStatusId = null"
           :class="[{ disabled: statusIsDisabled(status) }, status.slug]"
           v-for="status in focusTasks">
        <h3>
          <template v-if="status.slug === 'to-do'">
            <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="dot-circle"
                 class="svg-inline--fa fa-dot-circle fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
              <path fill="currentColor" d="M256 56c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200
                  0-110.532 89.451-200 200-200m0-48C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0
                  168c-44.183 0-80 35.817-80 80s35.817 80 80 80 80-35.817 80-80-35.817-80-80-80z"></path>
            </svg>
          </template>
          <template v-if="status.slug === 'in-progress'">
            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="spinner"
                 class="svg-inline--fa fa-spinner fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg"
                 viewBox="0 0 512 512">
              <path fill="currentColor" d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48
                  368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49
                  48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49
                  48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156
                  0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48
                  21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"></path>
            </svg>
          </template>
          <template v-if="status.slug === 'in-review'">
            <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="eye"
                 class="svg-inline--fa fa-eye fa-w-18" role="img" xmlns="http://www.w3.org/2000/svg"
                 viewBox="0 0 576 512">
              <path fill="currentColor" d="M288 144a110.94 110.94 0 0 0-31.24 5 55.4 55.4 0 0 1 7.24 27 56 56 0 0 1-56 56 55.4
                  55.4 0 0 1-27-7.24A111.71 111.71 0 1 0 288 144zm284.52 97.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48
                  241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0
                  0-29.19zM288 400c-98.65 0-189.09-55-237.93-144C98.91 167 189.34 112 288 112s189.09 55 237.93 144C477.1 345 386.66 400 288 400z"></path>
            </svg>
          </template>
          <template v-if="status.slug === 'completed'">
            <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="check-circle"
                 class="svg-inline--fa fa-check-circle fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg"
                 viewBox="0 0 512 512">
              <path fill="currentColor" d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8
                  256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532
                  89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346
                  303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068
                  16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"></path>
            </svg>
          </template>
          {{ status.name }}
          <span>
            <template v-if="hasActiveFilters">
              ({{ status.tasks.length }} of {{ status.count }})
            </template>
            <template v-else>
              ({{ status.count }})
            </template>
          </span>
        </h3>
        <div class="focus-tasks-drag-disabled-overlay"
             v-if="statusIsDisabled(status) && dragOverStatusId === status.id">
          <svg version="1.1" id="Layer_1" focusable="false" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
               x="0px" y="0px" viewBox="0 0 49 49" style="enable-background:new 0 0 49 49;" xml:space="preserve">
              <path class="st0" d="M24.5,0.5c-13.256,0-24,10.744-24,24s10.744,24,24,24s24-10.744,24-24S37.756,0.5,24.5,0.5z M37.092,11.908
                c6.333,6.333,6.773,16.013,2,22.803L14.287,9.908C21.081,5.132,30.761,5.58,37.092,11.908z M11.908,37.092
                c-6.333-6.333-6.773-16.013-2-22.803l24.805,24.805C27.919,43.868,18.239,43.42,11.908,37.092z"/>
              </svg>
          <template v-if="status.slug === 'completed'">This task requires Clear Assured validation before completion. When it's done, move it to 'Submitted for review'.</template>
          <template v-if="status.slug === 'in-review'">This is a self assessed task so there is no need to submit it for review. Once it’s done, simply move it to 'Completed'.</template>
        </div>
        <draggable class="focus-tasks-group"
                   tag="ul"
                   v-model="status.tasks"
                   v-bind="dragOptions(status)"
                   @start="drag = true"
                   @end="dragEnd()"
                   @change="handleChange($event, status)"
                   draggable=".task"
                   :class="{hidden: statusIsDisabled(status) && dragOverStatusId === status.id}"
                   group="focusTasks">
          <transition-group type="transition" :name="!drag ? 'flip-list' : null">
            <li class="focus-tasks-group-item task"
                v-for="task in status.tasks"
                @click.prevent="goToTask(task.id)"
                @dragstart="draggingItem(task, true)"
                @dragend="draggingItem(task, false)"
                :key="task.id">
              <div class="focus-tasks-group-item-name">
                {{ task.title }}
              </div>
              <div class="focus-tasks-group-item-meta">
                <div>
                  <div class="focus-tasks-group-item-meta-key">
                    {{ task.key }}
                  </div>
                  <div class="focus-tasks-group-item-meta-chapter" v-if="task.chapter && getChapterById(task.chapter)">
                    <div class="focus-tasks-group-item-meta-chapter-progress">
                      <div class="focus-tasks-group-item-meta-chapter-image"
                           v-bind:style="{backgroundImage: getChapterBackground(getChapterById(task.chapter)) }"></div>
                      <svg class="progress" width="130" height="130" viewBox="0 0 100 100">
                        <circle class="progress_meter" cx="50" cy="50" r="44" stroke-width="5"/>
                        <circle class="progress_value"
                                :class="'filters_progress_value-' + getChapterById(task.chapter)['id']"
                                cx="50" cy="50" r="44"
                                v-if="getUserRole !== 'ta' && getUserRole !== 'tu'"
                                stroke-width="5"/>
                      </svg>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="focus-tasks-group-item-meta-properties">
                    <div class="focus-tasks-group-item-meta-property recurrency" v-if="task.recurrent">
                      <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="sync-alt"
                           class="svg-inline--fa fa-sync-alt fa-w-16"
                           role="img" xmlns="http://www.w3.org/2000/svg"
                           viewBox="0 0 512 512">
                        <path fill="currentColor" d="M370.72 133.28C339.458 104.008 298.888 87.962 255.848 88c-77.458.068-144.328
                          53.178-162.791 126.85-1.344 5.363-6.122 9.15-11.651 9.15H24.103c-7.498 0-13.194-6.807-11.807-14.176C33.933
                          94.924 134.813 8 256 8c66.448 0 126.791 26.136 171.315 68.685L463.03 40.97C478.149 25.851 504 36.559 504
                          57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.749zM32 296h134.059c21.382
                          0 32.09 25.851 16.971 40.971l-41.75 41.75c31.262 29.273 71.835 45.319 114.876 45.28 77.418-.07 144.315-53.144
                          162.787-126.849 1.344-5.363 6.122-9.15 11.651-9.15h57.304c7.498 0 13.194 6.807 11.807 14.176C478.067 417.076 377.187
                          504 256 504c-66.448 0-126.791-26.136-171.315-68.685L48.97 471.03C33.851 486.149 8 475.441 8 454.059V320c0-13.255 10.745-24 24-24z"></path>
                      </svg>
                    </div>
                    <div class="focus-tasks-group-item-meta-property mandatory" v-if="task.mandatory">
                      <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="exclamation-circle"
                           class="svg-inline--fa fa-exclamation-circle fa-w-16"
                           role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                        <path fill="currentColor" d="M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248
                          111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418
                          136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884
                          0-12.356 5.78-11.981 12.654z"></path>
                      </svg>
                    </div>
                  </div>
                  <div class="focus-tasks-group-item-meta-user-info">
                    <!--                    <div class="focus-tasks-group-item-meta-user priority" v-bind:class="['priority-' + taskPriorityDelta(task.score)]">-->
                    <!--                      <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="arrow-up"-->
                    <!--                           class="svg-inline&#45;&#45;fa fa-arrow-up fa-w-14" role="img"-->
                    <!--                           xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">-->
                    <!--                        <path fill="currentColor" d="M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6-->
                    <!--                          0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z"></path>-->
                    <!--                      </svg>-->
                    <!--                    </div>-->
                    <div class="focus-tasks-group-item-meta-user user-avatar">
                      <template v-if="taskAssigneeById(task.assignee)">
                        <span v-if="taskAssigneeById(task.assignee).image" v-bind:style="{ backgroundImage: 'url(\'' + imageBase + taskAssigneeById(task.assignee).image + '\')' }"></span>
                        <avatar v-else :username="taskAssigneeById(task.assignee).label" :size="32" color="#ffffff"></avatar>
                      </template>
                      <template v-else>
                        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="user-circle"
                             class="svg-inline--fa fa-user-circle fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg"
                             viewBox="0 0 496 512">
                          <path fill="currentColor" d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0
                                88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4
                                55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1
                                7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z"></path>
                        </svg>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </transition-group>
        </draggable>
      </div>
    </div>
  </div>
</template>

<script>
  import api from '@/api'
  import draggable from 'vuedraggable'
  import {mapActions, mapGetters} from 'vuex'
  import Avatar from 'vue-avatar'

  export default {
    name: 'focus-tasks',
    props: {
      company: Number
    },
    data () {
      return {
        focusTasks: [],
        drag: false,
        allDragOptions: {
          animation: 200,
          group: 'description',
          disabled: false,
          delay: 200,
          delayOnTouchOnly: true,
          ghostClass: 'ghost'
        },
        inReviewDragOptions: {
          animation: 200,
          group: 'description',
          disabled: false,
          delay: 200,
          delayOnTouchOnly: true,
          ghostClass: 'ghost'
        },
        completedDragOptions: {
          animation: 200,
          group: 'description',
          disabled: false,
          delay: 200,
          delayOnTouchOnly: true,
          ghostClass: 'ghost'
        },
        dragOverStatusId: null
      }
    },
    computed: {
      ...mapGetters([
        'getUserRole',
        'selectedHightCont',
        'taskChapters',
        'taskAssigneeForSelect',
        'isAdmin'
      ]),
      searchParams () {
        const filters = {}
        let empty = true
        if (this.$route.query.ft) {
          filters['text'] = decodeURIComponent(this.$route.query.ft)
          empty = false
        }
        if (this.$route.query.fc) {
          filters['chapters'] = decodeURIComponent(this.$route.query.fc).split(',')
          empty = false
        }
        if (this.$route.query.fa) {
          filters['assignee'] = decodeURIComponent(this.$route.query.fa).split(',')
          empty = false
        }
        if (empty) {
          return false
        }
        return encodeURIComponent(JSON.stringify(filters))
      },
      hasActiveFilters () {
        let hasFilters = false
        if (
          this.$route.query.ft ||
          this.$route.query.fc ||
          this.$route.query.fa
        ) {
          hasFilters = true
        }
        return hasFilters
      },
      imageBase () {
        return api.serverUserImages
      }
    },
    methods: {
      ...mapActions([
        'getTaskStatuses'
      ]),
      handleChange (value, status) {
        this.moveTask(status, value)
        if (value.hasOwnProperty('added')) {
          status.count++
        }
        if (value.hasOwnProperty('removed')) {
          status.count--
        }
        // this.setChaptersProgress(100)
      },
      moveTask (status, value) {
        const statusColumn = this.focusTasks.find((item) => item.id === status.id)
        if (!statusColumn) {
          return
        }
        const data = {
          targetStatus: statusColumn.id,
          indexes: this.generateNewTasksOrder(statusColumn),
          filtered: this.hasActiveFilters
        }
        if (value.hasOwnProperty('added')) {
          data['action'] = 'added'
          data['taskId'] = value.added.element.id
          data['newIndex'] = parseInt(value.added.newIndex)
        }
        if (value.hasOwnProperty('moved')) {
          data['action'] = 'moved'
          data['taskId'] = value.moved.element.id
          data['newIndex'] = parseInt(value.moved.newIndex)
        }
        if (value.hasOwnProperty('removed')) {
          data['action'] = 'removed'
          data['newIndex'] = parseInt(value.removed.newIndex)
        }
        if (this.company) {
          data['company'] = this.company
        }
        this.$http.post(`${api.URLS.task}/move`, data, api.headersAuthSettings).then(() => {
          if (value.hasOwnProperty('added')) {
            this.getTaskStatuses(this.company)
          }
        }).catch((err) => {
          console.log(err)
        })
      },
      generateNewTasksOrder (status) {
        const order = []
        for (let i = 0; i < status.tasks.length; i++) {
          order.push(status.tasks[i]['id'])
        }
        return order
      },
      goToTask (taskId) {
        const routeName = this.isAdmin ? 'company-task' : 'task'
        const routeParams = {
          id: taskId
        }
        if (this.company) {
          routeParams['companyId'] = this.company
        }
        let props = this.$router.resolve({
          name: routeName,
          params: routeParams
        })
        this.$router.push(props.href)
      },
      getChapterById (id) {
        return this.taskChapters.find((item) => item.id === id)
      },
      getChapterBackground (chapter) {
        if (this.selectedHightCont === 1) {
          return 'url(' + chapter.image_high + ')'
        } else {
          return 'url(' + chapter.image + ')'
        }
      },
      setChaptersProgress (timeout) {
        timeout = timeout || 1000
        let self = this
        setTimeout(function () {
          self.taskChapters.forEach(function (chapter) {
            let score = chapter.score
            let selector = '.focus-tasks .filters_progress_value-' + chapter.id
            self.setCompanyProgress(score, selector)
          })
        }, timeout)
      },
      setCompanyProgress (value, selector) {
        let RADIUS = 44
        let CIRCUMFERENCE = 2 * Math.PI * RADIUS
        let progressValue = document.querySelectorAll(selector)
        if (progressValue.length) {
          for (let i = 0; i < progressValue.length; i++) {
            let progress = value / 100
            if (progressValue[i]) {
              progressValue[i].style.opacity = 1
              progressValue[i].style.strokeDasharray = CIRCUMFERENCE
              progressValue[i].style.strokeDashoffset = CIRCUMFERENCE * (1 - progress)
            }
          }
        }
      },
      draggingItem (task, state) {
        if (this.isAdmin) {
          return
        }
        if (task.assessed) {
          this.inReviewDragOptions.disabled = state
        } else {
          this.completedDragOptions.disabled = state
        }
        const header = document.querySelector('.app-header-main')
        if (state) {
          header.classList.add('absolute-positioned')
        } else {
          header.classList.remove('absolute-positioned')
        }
      },
      dragOverHandle (id) {
        setTimeout(function () {
          const element = document.getElementById('statusColumn-' + id)
          const container = document.querySelector('.focus-tasks-columns')

          let cLeft = container.scrollLeft
          let cRight = cLeft + container.clientHeight

          let eLeft = element.offsetLeft
          let eRight = eLeft + element.clientHeight

          if (eLeft < cLeft && eRight > cLeft) {
            container.scrollLeft -= (cLeft - eLeft)
          } else if (eRight > cRight && eLeft < cRight) {
            container.scrollLeft += (eRight - cRight)
          }
        }, 400)
        this.dragOverStatusId = id
      },
      dragEnd () {
        this.drag = false
        this.dragOverStatusId = null
      },
      dragOptions (status) {
        if (status.slug === 'in-review') {
          return this.inReviewDragOptions
        } else if (status.slug === 'completed') {
          return this.completedDragOptions
        } else {
          return this.allDragOptions
        }
      },
      statusIsDisabled (status) {
        if (this.isAdmin) {
          return
        }
        if (status.slug === 'in-review') {
          return this.inReviewDragOptions.disabled
        } else if (status.slug === 'completed') {
          return this.completedDragOptions.disabled
        } else {
          return this.allDragOptions.disabled
        }
      },
      getData () {
        const searchParams = this.searchParams
        let actionURL = `${api.URLS.task}/all/focus`
        if (searchParams) {
          if (this.company) {
            actionURL += `?company=${this.company}&filters=${searchParams}`
          } else {
            actionURL += `?filters=${searchParams}`
          }
        } else if (this.company) {
          actionURL += `?company=${this.company}`
        }
        this.$http.get(`${actionURL}`, api.headersAuthSettings)
          .then((res) => {
            this.focusTasks = res.body
            this.$store.commit('setFocusTasks', res.body)
            // this.setChaptersProgress()
          })
          .catch((err) => {
            console.log(err)
          })
      },
      taskAssigneeById (id) {
        const assignee = this.taskAssigneeForSelect.find((item) => item.value === id)
        if (assignee && assignee.value) {
          return assignee
        }
        return null
      },
      taskPriorityDelta (value) {
        let priorityDelta = 0
        if (value <= 33) {
          priorityDelta = 0
        } else if (value > 33 && value <= 66) {
          priorityDelta = 1
        } else if (value > 66 && value <= 100) {
          priorityDelta = 2
        }
        return priorityDelta
      }
    },
    components: {
      draggable,
      Avatar
    },
    watch: {
      '$route' (to, from) {
        if ((to.params.companyId && from.params.companyId && to.params.companyId !== from.params.companyId) || (to.hash !== from.hash && to.hash === '#focus')) {
          this.getData()
        }
      },
      taskChapters (value) {
        if (value) {
          // this.setChaptersProgress()
        }
      },
      searchParams () {
        this.getData()
      }
    },
    created () {
      this.getData()
    },
    mounted () {
      // this.setChaptersProgress()
    }
  }
</script>

<style src="@/assets/scss/components/tasks/focus-tasks.scss" lang="scss" scoped />



// WEBPACK FOOTER //
// FocusTasks.vue?431c8a65